import { useEffect, useRef, useState } from 'react'
import Invoices from '../../components/Disbursment/Invoices';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { get_disbursment_invoices,get_consolidate_disbursment_invoices} from '../../helper/Api';
import {
    GET_D_INVOICES_START,
    GET_D_INVOICES_SUCCESS,
    GET_D_INVOICES_FAIL
} from '../../RTK/Slices/DisbursmentInvoiceSlice';
import { useDispatch, useSelector } from 'react-redux';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import CreateButton from '../../components/Tools/CreateButton';


const InvoiceList = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const dateColumnRef = useRef('voucher_date');
    const searchStrRef = useRef('');
    const tierRef = useRef('');
    const departmentIdRef = useRef('');
    const departmentId1Ref = useRef('');
    const departmentRef = useRef([]);
    const [filter, setFilter] = useState('own');
    const [data, setData] = useState([]);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const handleDateChange = (dateColumn,searchStr,fyId, tier, departmentId, departmentId1) => {
        dateColumnRef.current=dateColumn;
        searchStrRef.current = searchStr;
        tierRef.current = tier;
        fyIdRef.current = fyId;
        departmentRef.current = departmentId;
        departmentId1Ref.current = departmentId1;
        if (filter == 'child') {
            fetchInvoices({
                dateColumn:dateColumnRef.current,
                search_str: searchStrRef.current,
                fy_id: fyIdRef.current,
                department_id:departmentRef.current,
            });
        }
        else if (filter == 'consolidate') {
            fetchInvoiceConsolidate();
        }
    };

    function structureData(data) {
        const sanctionMap = new Map();

        data.forEach(item => {
            const sanctionId = item.sanction_order_id;
            const voucherId = item.voucher_id;
            const invoiceAmount = parseFloat(item.invoice_value || 0);

            // Create sanction order if not exists
            if (!sanctionMap.has(sanctionId)) {
            sanctionMap.set(sanctionId, {
                sanction_order_id: sanctionId,
                sanction_order_no: item.sanction_order_no,
                sanction_order_date: item.sanction_order_date,
                sanction_order_url: item.sanction_order,
                vouchers: new Map(),
                sanction_amount: 0
            });
            }

            const sanction = sanctionMap.get(sanctionId);

            // Create voucher if not exists
            if (!sanction.vouchers.has(voucherId)) {
            sanction.vouchers.set(voucherId, {
                voucher_id: voucherId,
                voucher_no: item.voucher_no,
                voucher_date: item.voucher_date,
                voucher_url: item.voucher,
                invoices: [],
                voucher_amount: 0
            });
            }

            const invoice = { ...item };

            // Push invoice and add to amounts
            const voucher = sanction.vouchers.get(voucherId);
            voucher.invoices.push(invoice);
            voucher.voucher_amount += invoiceAmount;
            sanction.sanction_amount += invoiceAmount;
        });

        // Convert nested maps to arrays
        const result = [];
        sanctionMap.forEach(sanction => {
            sanction.vouchers = Array.from(sanction.vouchers.values());
            result.push(sanction);
        });

        return result;
    }




    const fetchInvoices = async (payload) => {
        dispatch(GET_D_INVOICES_START());
        try {
            const invoices_response = await get_disbursment_invoices(payload);
            if (invoices_response.data.status) {
                dispatch(GET_D_INVOICES_SUCCESS(invoices_response.data.list))
                setData(structureData(invoices_response.data.list))
            } else {
                dispatch(GET_D_INVOICES_FAIL(invoices_response.data.message))
            }
        } catch (error) {
            dispatch(GET_D_INVOICES_FAIL('something went wrong'))
        }
    }
    const fetchInvoiceConsolidate = async () => {
        try {
            let departmentId = '';
            if (departmentIdRef.current !== "" && departmentId1Ref.current !== "") {
                // You can decide which value to send, for example, let's choose departmentIdRef.current
                departmentId = departmentId1Ref.current;
            }
            else {
                departmentId = departmentIdRef.current;
            }
            const invoiceData = await get_consolidate_disbursment_invoices({
                department_id: departmentId || 1,
                fy_id: fyIdRef.current || '',
                search_str: searchStrRef.current || '',
                dateColumn:dateColumnRef.current||""
            });
            if (invoiceData.data.status) {
                dispatch(GET_D_INVOICES_SUCCESS(invoiceData.data.list))
                setData(invoiceData.data.list)
            } else {
                dispatch(GET_D_INVOICES_FAIL('something went wrong'))
            }
        } catch (error) {
            dispatch(GET_D_INVOICES_FAIL('something went wrong'));
        }

    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const newReportType = queryParams.get('reportType') || 'own';  // default fallback
        setFilter(newReportType);
        if (newReportType == 'own') {
            fetchInvoices({search_str: searchStrRef.current,department_id:departmentRef.current,fy_id: fyIdRef.current,dateColumn:dateColumnRef.current});
        }
        else{
            setData([]);
        }
    }, [location.search]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Vendor Payment</h4>
                        <CustomBreadcrumbs linksArray={[]} title="Vendor Payment"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button type="button" className="navigation_button" onClick={() => navigate("/fund-invoice-list?pending=false")}>
                                <span className="fs-14px">Invoice Approval</span>
                            </button>
                        </div>
                    </div>
                </div>
                <Invoices data={data} approval={false}/>
                { authData.user.user_type === 'l1' && <CreateButton title={"Add Sanction Order"} url={"/add-sanction-order"}/> }
            </div>
        </div>
    )
}
export default InvoiceList
